"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTupleSchemaComponent = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("react-hook-schema/core");
const hooks_1 = require("common/hooks");
const Property = ({ fieldPath, readOnly, control, property, selector: Field, }) => {
    const { title, schema, noLabel } = property;
    const { formatMessage } = (0, hooks_1.useFormatter)();
    const content = (react_1.default.createElement(Field, { control: control, fieldPath: fieldPath, readOnly: readOnly, schema: schema, label: title }));
    if (noLabel) {
        return content;
    }
    else
        return (react_1.default.createElement("div", { className: "field-pair", key: 0 },
            react_1.default.createElement("div", { className: "field-label" },
                react_1.default.createElement("label", { className: "label" },
                    react_1.default.createElement("span", { style: {
                            verticalAlign: "middle",
                        } }, title),
                    schema.required && !readOnly && !schema.readOnly && (react_1.default.createElement("span", { style: {
                            marginLeft: "4px",
                            verticalAlign: "middle",
                            padding: "1px 6px",
                            color: "#4E4C5A",
                            fontSize: "8px",
                            fontWeight: 700,
                            borderRadius: "6px",
                            whiteSpace: "nowrap",
                            backgroundColor: "#FACC15",
                        } }, formatMessage("Field.Required"))))),
            react_1.default.createElement("div", { className: "field-content" }, content)));
};
const createTupleSchemaComponent = (selectorGenerator) => ({ fieldPath, readOnly, control, schema, }) => {
    const properties = schema.elements;
    return (react_1.default.createElement("div", { className: "stacked-form" }, properties === null || properties === void 0 ? void 0 : properties.map((property, index) => (react_1.default.createElement(Property, { selector: selectorGenerator(), schema: property.schema, control: control, readOnly: readOnly, fieldPath: (0, core_1.joinFieldPath)(fieldPath, String(index)), key: index, property: property })))));
};
exports.createTupleSchemaComponent = createTupleSchemaComponent;
